export const addSpacesToNumber = (number: string | null | undefined, spaceIdx: number[]) => {
  if (!number) return '';

  // remove spaces and not digit symbols before formatting
  const cleanedNumber = number.replace(/\D/g, '');

  // add spaces according to format
  const formattedNumber = [...cleanedNumber]
    .map((letter, i) => (spaceIdx.includes(i) ? ` ${letter}` : letter))
    .join('');

  return formattedNumber;
};
